import { Panel } from '../../components/Panel';

// 認証/ロール制御の有効化フラグ（MVP では未設定=無効）
export const USER_AUTH_ENABLED = import.meta.env.VITE_ENABLE_USER_AUTH === 'true';

// 管理者が割り当て可能なロール（pending は登録時のみ自動付与）
export const ROLES = [
  { value: 'admin', label: '管理者' },
  { value: 'general', label: '一般' },
];

export const ROLE_LABEL: Record<string, string> = {
  admin: '管理者',
  general: '一般',
  pending: '承認待ち',
};

export const ROLE_COLOR: Record<string, string> = {
  admin: 'bg-red-100 text-red-800',
  general: 'bg-blue-100 text-blue-800',
  pending: 'bg-amber-100 text-amber-800',
};

// 利用可能（=リダイレクト対象外）なロール
export function isActiveRole(role?: string): boolean {
  return role === 'admin' || role === 'general';
}

export function RolePermissionTable() {
  return (
    <Panel title="ロール権限一覧">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b">
            <th className="text-left pb-2 pr-3">機能</th>
            <th className="text-center pb-2 pr-3">管理者</th>
            <th className="text-center pb-2 pr-3">一般</th>
          </tr>
        </thead>
        <tbody>
          {[
            ['アップロード・OCR', true, true],
            ['注文入力・保存', true, true],
            ['注文一覧・CSV', true, true],
            ['マスタ管理', true, true],
            ['ユーザー管理', true, false],
          ].map(([label, admin, general]) => (
            <tr key={label as string} className="border-b last:border-0">
              <td className="py-2 pr-3">{label as string}</td>
              <td className="py-2 pr-3 text-center">{admin ? '○' : '-'}</td>
              <td className="py-2 pr-3 text-center">{general ? '○' : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
}
